import { NUMBER_PATTERN } from 'utils/patterns/number';

export const extractNumbers = (string) => (string.match(NUMBER_PATTERN));
  
